import { api } from "../../api"

const MODULE_URL = "projects"

const projectService = api.injectEndpoints({
    endpoints: build => ({
        // Queries
        getFormStepDetail: build.query<any, { page: number; project_id: string }>({
            query: params => ({
                url: `${MODULE_URL}/get_project_details`,
                params: params,
            }),
            providesTags: (result, error, args) => [{ type: "Projects", id: args.project_id }],
        }),
        getProjectChargerTemplate: build.query<string, void>({
            query: () => ({
                url: `${MODULE_URL}/charger_template`,
            }),
            transformResponse: (response: [{ url: string }, number]) => {
                return response[0].url
            },
        }),
        getEcomOrderIds: build.query<{ id: string; title: string }[], void>({
            query: () => ({
                url: `${MODULE_URL}/ecom_order_ids`,
            }),
            transformResponse: (response: any) =>
                (response?.data?.message ?? []).map((item: any) => ({ id: item, title: String(item) })),
        }),
        // Mutations
        addProjectTicket: build.mutation({
            query: body => ({
                url: `${MODULE_URL}/tickets`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Projects"],
        }),
        updateProjectTicket: build.mutation({
            query: body => ({
                url: `${MODULE_URL}/tickets`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Projects"],
        }),
        addProjectTicketChargers: build.mutation({
            query: body => ({
                url: `add_charger`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Projects"],
        }),
        updateProjectTicketChargers: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `update_charger`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Projects"],
        }),
    }),
})

export const {
    // Queries
    useGetFormStepDetailQuery,
    useGetProjectChargerTemplateQuery,
    useGetEcomOrderIdsQuery,
    // Mutations
    useAddProjectTicketChargersMutation,
    useUpdateProjectTicketChargersMutation,
} = projectService
